module.exports = __webpack_public_path__ + "assets/img/Auxiliary materials (14).306f8c4c.png";